import React, { useState } from "react";
import { ArrowRight, Loader2, Lock } from "lucide-react";
import { login } from "@/api/auth";
import CarrierSignal from "@/components/CarrierSignal";

export default function Login({ onSuccess, titel = "MORPHEUS", untertitel = null }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      onSuccess?.();
    } catch (err) {
      setError(err.message || "Login fehlgeschlagen");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-void grid-veil flex flex-col items-center justify-center px-5 relative overflow-hidden">
      {/* ambient glow */}
      <div
        className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[680px] h-[680px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(230,57,70,0.16), rgba(var(--signal-rgb),0.05) 40%, transparent 70%)" }}
      />

      <div className="login-enter relative z-10 w-full max-w-md flex flex-col items-center">
        <p className="eyebrow mb-5">Artist Operating System // v1.0</p>

        <h1 className="font-display text-6xl sm:text-7xl font-semibold text-white tracking-tight leading-none">
          {titel}
        </h1>

        {untertitel || (<p className="text-ether mt-4 text-center text-sm leading-relaxed max-w-xs">
          Der autonome CEO des Fünkenstein-Universums.
          <br />Drei Brands, ein Betriebssystem.
        </p>)}

        <div className="w-full mt-8 mb-2">
          <CarrierSignal active={loading} />
        </div>

        <form onSubmit={submit} className="w-full mt-4 space-y-3">
          <div>
            <label className="eyebrow block mb-2">E-Mail</label>
            <input
              type="email"
              name="username" id="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              placeholder="du@beispiel.com"
              className="w-full rounded-xl bg-panel border border-white/10 px-4 py-3 text-white placeholder:text-white/25 outline-none transition focus:border-[var(--signal)] focus:ring-2 focus:ring-[rgba(var(--signal-rgb),0.3)]"
            />
          </div>

          <div>
            <label className="eyebrow block mb-2">Passwort</label>
            <input
              type="password"
              name="password" id="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              placeholder="••••••••••••"
              className="w-full rounded-xl bg-panel border border-white/10 px-4 py-3 text-white placeholder:text-white/25 outline-none transition focus:border-[var(--signal)] focus:ring-2 focus:ring-[rgba(var(--signal-rgb),0.3)]"
            />
          </div>

          {error && (
            <p className="text-flare text-sm font-mono-ui pt-1">{"// "}{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="group w-full mt-2 rounded-xl bg-[var(--signal)] text-[var(--void)] font-display font-semibold text-base py-3.5 flex items-center justify-center gap-2 transition hover:brightness-105 disabled:opacity-60 glow-signal"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Verbinde…
              </>
            ) : (
              <>
                Einloggen
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
              </>
            )}
          </button>
        </form>

        <p className="eyebrow mt-8 flex items-center gap-2 opacity-70">
          <Lock className="w-3 h-3" />
          Gesicherter Zugang · funkenstein.eu
        </p>
      </div>
    </div>
  );
}
